<!-- 订单拆分, 将一条订单详情拆分成多条详情 -->
<template>
<el-dialog :title="msg('订单拆分')" :visible.sync="visible" :fullscreen="true"
    :close-on-click-modal="false" 
>
    <div>
         <!-- 添加顶部按钮 -->
        <div class="button-group">
            <el-button type="primary" icon="el-icon-s-promotion" :loading="spliting" size="small" @click="handleSplit">执行拆分</el-button>
            <el-button type="success" icon="el-icon-check" :loading="saving" size="small" @click="handleSave">确定保存</el-button>
            <el-button type="danger" plain icon="el-icon-close" size="small" @click="handleCancel">关闭</el-button>
        </div>
    
        <div class="split-container">
            <!-- 整体表头 -->
            <div class="header-row">
                <!-- 左侧表头 -->
                <div class="left-header" style="width: 300px">
                    <div class="info-item">
                        <span class="label">订单</span>
                    </div>
                </div>
                
                <!-- 箭头占位 -->
                <div class="arrow-icon">
                    <i class="el-icon-right"></i>
                </div>
                
                <!-- 右侧表头 -->
                <div class="right-header">
                    <el-row class="table-row">
                        <el-col :span="7">商品名称</el-col>
                        <el-col :span="7">规格</el-col>
                        <el-col :span="6">SKU</el-col>
                        <el-col :span="4">数量</el-col>
                    </el-row>
                </div>
            </div>

            <!-- 数据行 -->
            <div v-for="stock in stocks" :key="stock.id" class="split-item">
                <!-- 左侧内容 -->
                <div class="left-info">
                    <div class="info-item">
                        <span>{{ stock.code }}</span>
                    </div>
                    <div class="info-item">
                        <el-input 
                            v-model="stock.productTitle" 
                            rows="2" 
                            type="textarea" 
                            size="small"
                            @input="handleTitleChange(stock)"
                        ></el-input>
                    </div>
                </div>
                
                <!-- 箭头图标 -->
                <div class="arrow-icon">
                    <i class="el-icon-right"></i>
                </div>
                
                <!-- 右侧表格内容 -->
                <div class="right-table">
                    <div v-for="(detail, index) in stock.details" :key="index" class="table-row">
                        <el-row class="table-row">
                            <el-col :span="7">
                                <el-input v-model="detail.productName" size="small"></el-input>
                            </el-col>
                            <el-col :span="7">
                                <el-input v-model="detail.productSpec" size="small"></el-input>
                            </el-col>
                            <el-col :span="6">
                                <el-input v-model="detail.sku" size="small"></el-input>
                            </el-col>
                            <el-col :span="4">
                                <el-input-number 
                                    v-model="detail.productQty" 
                                    size="small"
                                    :min="0"
                                    controls-position="right"
                                ></el-input-number>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
         <!-- 添加顶部按钮 -->
        <div class="button-group" v-if="stocks.length>15">
            <el-button type="primary" icon="el-icon-s-promotion" :loading="spliting" size="small" @click="handleSplit">执行拆分</el-button>
            <el-button type="success" icon="el-icon-check" :loading="saving" size="small" @click="handleSave">确定保存</el-button>
            <el-button type="danger" plain icon="el-icon-close" size="small" @click="handleCancel">关闭</el-button>
        </div>
    </div>
</el-dialog>
</template>
<script>
export default {
    name: 'OrderSplitDialog',
    data(){
        return {
            visible: false,
            stocks: [],
            spliting: false,
            saving: false,
        }
    },
    methods: {
        showDialog(ids){
            this.visible = true;
            this.stocks = [];
            this.spliting = false;
            this.saving = false;
            this.$axios.get(
                this.$kit.api.stockDetail.orderSplitList+"?ids="+ids
            ).then(res => {
                if(res.status){
                    for(let k = 0; k<res.data.length; k++){
                        let stock = res.data[k];
                        if(stock.productSpec && stock.sku){
                            continue;
                        }

                        stock.originalTitle = stock.productTitle;
                        let detail = {...stock};
                        stock.details = [];
                        stock.details.push(detail);
                        this.stocks.push(stock);
                    }
                }else{
                    this.$message.error(res.msg);
                }
            })
        },
        handleSave() {
            this.saving = true;
            let details = [];
            
            this.stocks.forEach(stock => {
                stock.details.forEach(detail => {
                    details.push(detail);
                });
            });

            if(details.length == 0){
                this.$message(this.msg('无可提交的有效数据'));
                return;
            }

            this.$axios.post(
                this.$kit.api.stockDetail.orderSplitSave,
                details
            ).then(res => {
                if(res.status){
                    this.$message.success(this.msg('保存成功'));
                }else{
                    this.$message.error(res.msg);
                    this.saving = false;
                }
            }).catch(() => {
                this.saving = false;
            });
        },
        handleSplit(){
            this.spliting = true;
            let newStocks = [];

            for(let k = 0; k<this.stocks.length; k++){
                try{
                    let oldStock = this.stocks[k];
                    let stock = {...oldStock};
                    newStocks.push(stock);

                    if(stock.splited){
                        continue;
                    }

                    //七彩車載收納盒:米白色 主駕座 無LOGO ×1;米白色 副駕座 無LOGO ×1
                    let title = stock.productTitle;

                    let titleIndex = title.indexOf(":");
                    if(titleIndex == -1){
                        titleIndex = title.indexOf("：");
                    }

                    if(titleIndex == -1){
                        return;
                    }

                    let name = title.substring(0, titleIndex);
                
                    let infos1 = title.substring(titleIndex+1).split(/[;；]+/);
                    let detail = stock.details[0];
                    for(let i=0; i<infos1.length; i++){
                        let infos2 = infos1[i].split(/[Xx\×\Ⅹ\*]+/);
                        let spec = infos2[0].replace(/\s+/g, '');
                        let qty = Number.parseInt(infos2[1]);

                        let productSpec = name+":"+spec;

                        let newDetail = {...detail,
                            productName: name,
                            productSpec: productSpec,
                            productQty: qty,
                            sku: productSpec,
                        }
                        
                        if(i==0){
                            stock.details[0] = newDetail;
                        }else{
                            newDetail.id = null;
                            newDetail.productPrice = 0;
                            stock.details.push(newDetail);
                        }
                    }
                    
                    stock.splited = true;
                    stock.originalTitle = stock.productTitle;
                   
                }catch(e){
                    console.log(e);
                    this.$message.error(this.msg('拆分失败'));

                }

            }
            this.stocks = newStocks;
            this.spliting = false;
        },
        handleCancel(){
            this.visible = false;
        },
        handleTitleChange(stock) {
            if (stock.originalTitle !== stock.productTitle) {
                stock.splited = false;
            }
        },
    }
}
</script>

<style scoped>
.el-input-number {
    width: 100%;
}

.table-row .el-input,
.table-row .el-input-number {
    margin: 2px 0;
}

/* 调整输入框高度 */
.table-row .el-input__inner {
    height: 32px;
    line-height: 32px;
}

/* 添加箭头样式 */
.arrow-icon {
    display: flex;
    align-items: center;
    padding: 0 20px;
    color: #909399;
    font-size: 20px;
}

/* 可选：添加箭头悬停效果 */
.arrow-icon i {
    transition: all 0.3s;
}

.arrow-icon i:hover {
    color: #409EFF;
    transform: scale(1.2);
}

/* 调整左侧信息和右侧表格的样式 */
.left-info {
    width: 300px;
    padding-right: 20px;
}

.right-table {
    flex: 1;
}

.header-row {
    display: flex;
    margin-bottom: 15px;
    background-color: #F5F7FA;
    padding: 15px;
    font-weight: bold;
    border: 1px solid #EBEEF5;
}

.left-header {
    padding-right: 20px;
}

.right-header {
    flex: 1;
}

.split-item {
    display: flex;
    margin-bottom: 10px;
    padding: 20px;
    border: 1px solid #EBEEF5;
}

.info-item {
    margin-bottom: 10px;
}

.table-row > *{
    padding-left: 4px;
    padding-right: 4px;
}
.button-group{
    margin-bottom: 10px;
    text-align: center;
}

</style>

